import React, { useEffect, useState } from "react";
import { DatePicker, Spin, message, Tooltip } from "antd";
import dayjs from "dayjs";
import { getBalanceSheetReport } from "../../../services/ReportApiService";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { ChevronUp } from "feather-icons-react";
import LoadingUtils from "../../../core/utils/LoadingUtils";
import { OverlayTrigger } from "react-bootstrap";
import { renderTooltip } from "../../../redux/helper";
import { exportreportExcel, exportreportPDF, printreportReport } from "../../../core/utils/MainReportUtils";
import { useSelector } from "react-redux";
import { Calendar } from "feather-icons-react/build/IconComponents";

function groupBy(arr, key) {
  const map = {};
  arr.forEach((item) => {
    const group = item[key] || "Others";
    if (!map[group]) map[group] = [];
    map[group].push(item);
  });
  return map;
}

function sumGroup(arr) {
  return arr.reduce((sum, item) => sum + (item.closingBalance || 0), 0);
}


function BalancesheetReport() {
  const [fromDate, setFromDate] = useState(dayjs().startOf("month"));
  const [toDate, setToDate] = useState(dayjs());
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
const {togglehead} = useSelector((state) => state.headerToggle);
const [pageSize, setPageSize] = useState(10);
const [currentPage, setCurrentPage] = useState(1);
const [searchText, setSearchText] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const DatatablePagingParameters = {
        PageNumber: 1,
        PageSize: -1,
        SearchValue: null,
        SortingColumn: null,
        SortingDirection: ""
      };
      const Filters = {
        FromDate: fromDate.format("YYYY-MM-DD"),
        ToDate: toDate.format("YYYY-MM-DD"),
        Section: null,
        Counter: null,
        PaymentType: null,
        PaymentCardType: null,
        DayClosed: 0,
        User: null,
        SaleStatus: null,
        ItemName: null,
        ShiftNumber: null,
        Waiter: null,
        IsLiveSale: 0,
        Product: null,
        Category: null,
        Group: null,
        Customer: null,
        AccountType: null,
        Type: null,
        SalesAuditStatus: null,
        EditType: null,
        Branch: {
          name: "Aspire Park",
          company: null,
          prefixInvoice: null,
          address1: null,
          address2: null,
          address3: null,
          phone: null,
          email: null,
          cloneBranchId: null,
          id: 0,
          guid: "f32e041d-3c15-493f-bb70-a31e4e90e98d",
          version: 0,
          isDeleted: false,
          createdUser: null,
          createdDate: "0001-01-01T00:00:00",
          updatedUser: null,
          updatedDate: "0001-01-01T00:00:00"
        },
        LedgerID: "00000000-0000-0000-0000-000000000000",
        FinancialYearID: 0
      };

      const response = await getBalanceSheetReport({ DatatablePagingParameters, Filters });
      setData(response.data);
    } catch (err) {
      message.error("Failed to fetch balance sheet data");
      setData(null);
    } finally {
      setLoading(false);
    }
  };
const getActiveTabData = () => {
  // Define columns for export
  const columns = [
    { title: "Group", dataIndex: "group" },
    { title: "Ledger", dataIndex: "ledger" },
    { title: "Debit", dataIndex: "debit" },
    { title: "Credit", dataIndex: "credit" },
    { title: "Closing Balance", dataIndex: "closingBalance" },
  ];

  // Map column titles to dataIndex
  const fieldMapping = {};
  columns.forEach((col) => {
    fieldMapping[col.title] = col.dataIndex;
  });

  // Combine assets and liabilities for export
  const dataList = [
    ...(data?.assets || []),
    ...(data?.liabilities || []),
  ];

  // Optionally add netPL and closingStock if needed for export
  // Example:
  // if (data?.netPL) {
  //   dataList.push({
  //     group: data.netPL.status,
  //     ledger: data.netPL.status,
  //     debit: null,
  //     credit: null,
  //     closingBalance: data.netPL.amount,
  //   });
  // }
  // if (data?.closingStock) {
  //   dataList.push({
  //     group: "Closing Stock",
  //     ledger: "Closing Stock",
  //     debit: null,
  //     credit: null,
  //     closingBalance: data.closingStock,
  //   });
  // }

  return {
    data: dataList,
    columns,
    fieldMapping,
    Rname: "Balance Sheet",
  };
};
// const footerTotals = {
//     totalAssets: DEFAULT_ASSET_GROUPS.reduce(   
//         (sum, group) => sum + sumGroup(groupBy(data?.assets || [], "group")[group] || []),
//         0
//     ),
//     totalLiabilities: DEFAULT_LIABILITY_GROUPS.reduce(
//         (sum, group) => sum + sumGroup(groupBy(data?.liabilities || [], "group")[group] || []), 
//         0
//     ),  
//     netPL: data?.netPL?.amount || 0,
//     closingStock: data?.closingStock || 0,  
// };

const assetGroups = groupBy(data?.assets || [], "group");
const liabilityGroups = groupBy(data?.liabilities || [], "group");

const netPL = data?.netPL?.amount || 0;
const netPLStatus = data?.netPL?.status || "";
const closingStock = data?.closingStock || 0;
const obDeference = data?.obDeference || 0;

// Sum totals
const totalAssetValue = Object.keys(assetGroups).reduce(
  (sum, group) => sum + sumGroup(assetGroups[group] || []),
  0
);

const totalLiabilityValue = Object.keys(liabilityGroups).reduce(
  (sum, group) => sum + sumGroup(liabilityGroups[group] || []),
  0
);

// Include netPL and closing stock correctly
const totalAssets = totalAssetValue +
  (netPLStatus === "Net Loss" ? netPL : 0) +
  closingStock +
  (totalLiabilityValue > totalAssetValue ? obDeference : 0);

const totalLiabilities = totalLiabilityValue +
  (netPLStatus === "Net Profit" ? netPL : 0) +
  (totalAssetValue > totalLiabilityValue ? obDeference : 0);


const companyInfolist = {
  companyName: data?.companyName || "Company Name",
  companyAddress: data?.companyAddress || "Company Address",
  companyContact: data?.companyContact || "Company Contact",
  companyEmail: data?.companyEmail || "Company Email",
};

const handletogglehead = () => {
  document.getElementById("collapse-header").classList.toggle("active");
  const header = document.querySelector(".page-header.transfer");
  if (header) {
    header.classList.toggle("collapsed");
  }
};

const handleReset = () => {
  setFromDate(dayjs().startOf("month"));
  setToDate(dayjs());
  fetchData();
};

const handleSearch = (e) => {
  setSearchText(e.target.value);
};

const handleFromDateChange = (date) => {
  setFromDate(date);
  setToDate(null); // reset to date when from date changes
};

const handleToDateChange = (date) => {
  setToDate(date);
};

useEffect(() => {
  fetchData();
  // eslint-disable-next-line
}, [fromDate, toDate]);

// Unique group extractor
const getGroups = (items) => [...new Set(items.map(item => item.group))];

  // Render only groups present in the response
  const renderGroupSection = (groups, groupData) =>
  groups.map((group) =>
    (groupData[group] && groupData[group].length > 0) ? (
      <React.Fragment key={group}>
        {groupData[group].map((item, idx) => (
          <tr key={item.ledger + idx}>
            <td>{item.group}</td>
            <td>{item.ledger}</td>
            <td style={{ textAlign: "right" }}>
              {item.debit != null ? item.debit.toLocaleString() : "—"}
            </td>
            <td style={{ textAlign: "right" }}>
              {item.credit != null ? item.credit.toLocaleString() : "—"}
            </td>
            <td style={{ textAlign: "right" }}>
              {item.closingBalance != null ? item.closingBalance.toLocaleString() : "—"}
            </td>
          </tr>
        ))}
        <tr style={{ background: "#e0e0e0", fontWeight: "bold" }}>
          <td colSpan={4}>Total {group.toLowerCase()}</td>
          <td style={{ textAlign: "right" }}>
            {sumGroup(groupData[group]).toLocaleString()}
          </td>
        </tr>
      </React.Fragment>
    ) : null
  );

  return (
     <div>
          <LoadingUtils loading={loading} />
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header transfer">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Balance Sheet</h4>
              <h6>Manage Balance Sheet Report Here</h6>
            </div>
          </div>
       <ul className="table-top-head">
                    <li>
                      <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                        <button
                          onClick={() =>
                            exportreportPDF(getActiveTabData)
                          }
                          disabled={loading}
                          className="btn btn-link bg-white rounded-lg border border-silver"
                        >
                          <ImageWithBasePath
                            src="assets/img/icons/pdf.svg"
                            alt="img"
                          />
                        </button>
                      </OverlayTrigger>
                    </li>
                    <li>
                      <OverlayTrigger
                        placement="top"
                        overlay={renderTooltip("Excel")}
                      >
                        <button
                          onClick={() =>
                            exportreportExcel(getActiveTabData)
                          }
                          disabled={loading}
                          className="btn btn-link bg-white rounded-lg border border-silver"
                        >
                          <ImageWithBasePath
                            src="assets/img/icons/excel.svg"
                            alt="excel-icon"
                          />
                        </button>
                      </OverlayTrigger>
                    </li>
                    <li>
                      <OverlayTrigger
                        placement="top"
                        overlay={renderTooltip("Print")}
                      >
                        <button
                          onClick={() =>
                            printreportReport(getActiveTabData, "Bank Book Report")
                          }
                          disabled={loading}
                          className="btn btn-link bg-white rounded-lg border border-silver"
                        >
                          <i data-feather="printer" className="feather-printer" />
                        </button>
                      </OverlayTrigger>
                    </li>
                    <li>
                      <OverlayTrigger
                        placement="top"
                        overlay={renderTooltip("Collapse")}
                      >
                        <Link
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          id="collapse-header"
                          className={togglehead ? "active" : ""}
                          onClick={handletogglehead}
                        >
                          <ChevronUp />
                        </Link>
                      </OverlayTrigger>
                    </li>
                  </ul>
        </div>
    <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
  {/* <div className="search-set">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                </div> */}
             <div className="search-set">
        <div className="search-input">
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <div className="input-group input-group-sm">
              <span className="input-group-text bg-white border-end-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-search"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </span>
              <input
                type="search"
                className="form-control border-start-0"
                placeholder="Search"
                value={searchText}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
 <div className="row gx-2 gy-2">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="input-blocks ">
                        <label>From Date</label>
                        <div className="input-groupicon calender-input">
                          <Calendar className="info-img" />
                          <DatePicker
                            className="datetimepicker"
                            id="from-date"
                            placeholderText="From Date"
                            // selected={fromDate}
                            value={fromDate}
                            onChange={handleFromDateChange}
                            startDate={fromDate}
                            selectsStart
                            allowClear
                            // dateFormat="dd/MM/yyyy"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="input-blocks">
                        <label>To Date</label>
                        <div className="input-groupicon calender-input">
                          <Calendar className="info-img" />
                          <DatePicker
                            id="to-date"
                            placeholderText="To Date"
                            // selected={toDate}
                            value={toDate}
                            onChange={handleToDateChange}
                            minDate={fromDate}
                            startDate={fromDate}
                            selectsEnd
                            disabled={!fromDate} // disable until from date is selected
                            // dateFormat="dd/MM/yyyy"
                            // className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                  </div>

   <div className="d-flex justify-content-end mt-3">
                  <div className="input-blocks me-2">
                    <button
                      className="btn btn-filters rounded-2 h-100 "
                      onClick={() => {
                        setCurrentPage(1);
                        setPageSize(20);
                fetchData();
                      }}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      Search
                    </button>
                  </div>

                  <div className="input-blocks">
                    <button
                      className="btn btn-reset  rounded-2 "
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                </div>
                </div>
                      
  
          <div className="card-body">
            {loading ? (
              <Spin />
            ) : (
              <div className="row">
                {/* Assets */}
                <div className="col-md-6">
                  <h4 className="text-success mb-2">Assets</h4>
                  <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Group</th>
            <th>Ledger</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Closing Balance</th>
          </tr>
        </thead>
        <tbody>
    {renderGroupSection(getGroups(data?.assets || []), assetGroups)}

{/* Show Closing Stock if exists */}
{closingStock !== 0 && (
  <tr>
    <td>Current Assets</td>
    <td>Closing Stock</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>{closingStock.toLocaleString()}</td>
  </tr>
)}

{/* Show Net Loss on Assets side */}
{netPLStatus === "Net Loss" && netPL !== 0 && (
  <tr>
    <td>Net Loss</td>
    <td>Net Loss</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>{netPL.toLocaleString()}</td>
  </tr>
)}

{/* Show OB Difference on Assets side if Liabilities > Assets */}
{totalLiabilities > totalAssets && obDeference !== 0 && (
  <tr>
    <td>Opening Balance Diff</td>
    <td>Opening Balance Diff</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>{obDeference.toLocaleString()}</td>
  </tr>
)}

<tr style={{ background: "#e0e0e0", fontWeight: "bold" }}>
  <td colSpan={4}>Total Assets</td>
  <td style={{ textAlign: "right" }}>{totalAssets.toLocaleString()}</td>
</tr>

        </tbody>
      </table>
    </div>
                </div>
                {/* Liabilities */}
                <div className="col-md-6">
                  <h4 className="text-success mb-2">Liabilities</h4>
                  <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Group</th>
            <th>Ledger</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Closing Balance</th>
          </tr>
        </thead>
        <tbody>
          {renderGroupSection(getGroups(data?.liabilities || []), liabilityGroups)}

{/* Show Net Profit on Liabilities side */}
{netPLStatus === "Net Profit" && netPL !== 0 && (
  <tr>
    <td>Net Profit</td>
    <td>Net Profit</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>{netPL.toLocaleString()}</td>
  </tr>
)}

{/* Show OB Difference on Liabilities side if Assets > Liabilities */}
{totalAssets > totalLiabilities && obDeference !== 0 && (
  <tr>
    <td>Opening Balance Diff</td>
    <td>Opening Balance Diff</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>—</td>
    <td style={{ textAlign: "right" }}>{obDeference.toLocaleString()}</td>
  </tr>
)}

<tr style={{ background: "#e0e0e0", fontWeight: "bold" }}>
  <td colSpan={4}>Total Liabilities</td>
  <td style={{ textAlign: "right" }}>{totalLiabilities.toLocaleString()}</td>
</tr>

        </tbody>
      </table>
    </div>
                </div>
              </div>
            )}
          </div>
  
      </div>
      </div>
    </div>
    </div>
    </div>

  );
}

export default BalancesheetReport;
